export default {
  Ok : 0,
  Warning : 1,
  BehindTarget : 2
};